import ExaminationResult from './ExaminationResult.vue';

export * from './types';
export default ExaminationResult;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/components/ExaminationResult/index.ts